import { envConfig } from "../../config/env.config";
import {
  IBasePagingRes,
  IBaseResponseModel
} from "../../models/common/models.type";
import {
  IN8NWorkflow,
  ICreateN8NWorkflowRequest,
  IUpdateN8NWorkflowRequest,
  IN8NWorkflowExecution,
  IN8NWorkflowsRequest
} from "../../models/n8n-workflow";
import ApiEndpoints from "../remote/apiEndpoints";
import api from "../remote/baseApi";

const API_N8N = ApiEndpoints.N8N_WORKFLOWS;
const baseURL = envConfig.N8N_BACKEND_ENDPOINT;

const getWorkflows = (
  params?: IN8NWorkflowsRequest
): Promise<IBasePagingRes<IN8NWorkflow>> => {
  return api.get(baseURL, API_N8N.GET_PAGE.url, { params });
};

const getWorkflow = (
  id: string
): Promise<IBaseResponseModel<IN8NWorkflow>> => {
  return api.get(baseURL, `${API_N8N.GET_SINGLE.url}/${id}`);
};

const createWorkflow = (
  params: ICreateN8NWorkflowRequest
): Promise<IBaseResponseModel<IN8NWorkflow>> => {
  return api.post(baseURL, API_N8N.CREATE.url, params);
};

const updateWorkflow = (
  id: string,
  params: IUpdateN8NWorkflowRequest
): Promise<IBaseResponseModel<IN8NWorkflow>> => {
  return api.put(baseURL, `${API_N8N.UPDATE.url}/${id}`, params);
};

const deleteWorkflow = (
  id: string
): Promise<IBaseResponseModel<string>> => {
  return api.delete(baseURL, `${API_N8N.DELETE.url}/${id}`);
};

const executeWorkflow = (
  id: string
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, `${API_N8N.EXECUTE.url}/${id}/execute`, {});
};

const getExecutions = (
  id: string,
  limit?: number
): Promise<IBaseResponseModel<IN8NWorkflowExecution[]>> => {
  return api.get(baseURL, `${API_N8N.GET_EXECUTIONS.url}/${id}/executions`, {
    params: { limit }
  });
};

const activateWorkflow = (
  id: string,
  active: boolean = true
): Promise<IBaseResponseModel<IN8NWorkflow>> => {
  return api.post(baseURL, `${API_N8N.EXECUTE.url}/${id}/activate`, { active });
};

const N8NWorkflowService = {
  getWorkflows,
  getWorkflow,
  createWorkflow,
  updateWorkflow,
  deleteWorkflow,
  executeWorkflow,
  getExecutions,
  activateWorkflow
};

export default N8NWorkflowService;